<template>
  <div class="spinner">
    <div class="spinner__circle spinner__circle--first"></div>
    <div class="spinner__circle spinner__circle--second"></div>
    <div class="spinner__circle spinner__circle--third"></div>
  </div>
</template>

<script>
export default {
  name: "spinner",
}
</script>



// WEBPACK FOOTER //
// Spinner.vue?459f9ea4